import { Line, LineColors } from './line';
import { ServiceLocator } from '@app/engine/core/service-locator';
export class SensorToMoonLine extends Line {
    sensor_;
    constructor(sensor) {
        super();
        this.sensor_ = sensor;
        this.color_ = LineColors.WHITE;
    }
    update() {
        const eci = this.sensor_.eci(ServiceLocator.getTimeManager().simulationTimeObj);
        const eciArr = [eci.x, eci.y, eci.z];
        this.updateVertBuf([eciArr, ServiceLocator.getScene().moons.Moon.position]);
    }
}
